const data = [
  {
    page: 1,
    question: "At the museum, you will look at this first..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA1.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB1.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC1.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD1.png",
    },
  },
  {
    page: 2,
    question: "Your style icon is..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA2.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB2.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC2.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD2.png",
    },
  },
  {
    page: 3,
    question: "The colors that catches your attention first..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA3.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB3.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC3.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD3.png",
    },
  },
  {
    page: 4,
    question: "Your ideal dating spot..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA4.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB4.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC4.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD4.png",
    },
  },
  {
    page: 5,
    question: "Your outfit for a show at the Esplanade..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA5.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB5.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC5.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD5.png",
    },
  },
  {
    page: 6,
    question: "The activity you will be interested..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA6.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB6.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC6.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD6.png",
    },
  },
  {
    page: 7,
    question: "You want travel to..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA7.png",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB7.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC7.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD7.png",
    },
  },
  {
    page: 8,
    question: "It's the weekends and you are likely doing..",
    answer: {
      A: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qA8.jpg",
      B: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qB8.png",
      C: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qC8.png",
      D: "https://cycquiz.s3.ap-southeast-1.amazonaws.com/images/qD8.png",
    },
  },
];

export default data;
